import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    solutions: [
      { label: "Retail Analytics", path: "/solutions-gallery" },
      { label: "Traffic Management", path: "/solutions-gallery" },
      { label: "Security Intelligence", path: "/solutions-gallery" },
      { label: "Business Intelligence", path: "/solutions-gallery" },
    ],
    company: [
      { label: "About Us", path: "https://do365tech.com/about-us" },
      { label: "Careers", path: "https://do365tech.com/career" },
      { label: "Contact", path: "https://do365tech.com/contact-us" },
    ],
    resources: [
      { label: "Documentation", path: "/implementation-hub" },
      { label: "Case Studies", path: "/industry-applications" },
      { label: "Blog", path: "/homepage" },
      { label: "Support", path: "/implementation-hub" },
    ],
    legal: [
      { label: "Privacy Policy", path: "/homepage" },
      { label: "Terms of Service", path: "/homepage" },
      { label: "Security", path: "/homepage" },
      { label: "Compliance", path: "/homepage" },
    ],
  };

  const socialLinks = [
    { icon: "Linkedin", label: "LinkedIn", url: "#" },
    { icon: "Twitter", label: "Twitter", url: "#" },
    { icon: "Facebook", label: "Facebook", url: "#" },
    { icon: "Youtube", label: "YouTube", url: "#" },
  ];


   const handleClick = (p:string) => {
    window.open(p);
  };


  return (
    <footer className="bg-authority-charcoal text-authority-charcoal-foreground">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <Link to="/homepage" className="flex items-center space-x-2 mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg">
                <img
                  src="/assets/images/favicon.svg"
                  alt="logo of camlytix"
                />
              </div>
              <span className="text-xl font-bold">Camlytix AI</span>
            </Link>
            <p className="text-sm text-authority-charcoal-foreground/70 mb-6 leading-relaxed">
              Transform vision into intelligence with AI-powered video analytics
              that deliver actionable insights for your business.
            </p>
            {/* <div className="flex gap-3">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.url}
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors duration-300"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div> */}
          </div>

          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider mb-4">
              Solutions
            </h3>
            <ul className="space-y-3">
              {footerLinks?.solutions?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-authority-charcoal-foreground/70 hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <button
                    onClick={()=>handleClick(link?.path)}
                    className="text-sm text-authority-charcoal-foreground/70 hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* <div>
            <h3 className="font-bold text-sm uppercase tracking-wider mb-4">
              Resources
            </h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-authority-charcoal-foreground/70 hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          <div>
            <h3 className="font-bold text-sm uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-authority-charcoal-foreground/70 hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-authority-charcoal-foreground/70">
              &copy; {currentYear} Camlytix AI. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} className="text-success" />
                <span className="text-xs text-authority-charcoal-foreground/70">
                  ISO 27001 Certified
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={16} className="text-success" />
                <span className="text-xs text-authority-charcoal-foreground/70">
                  GDPR Compliant
                </span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
